import $ from 'jquery';


import './../../scss/blocks/block-section10.scss';

$(document).ready(function() {


});